// src/features/promoteur/ChargilyPaymentFailure.jsx
import { Link } from "react-router-dom";

export default function ChargilyPaymentFailure() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f7f8fa",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "520px",
          background: "#ffffff",
          borderRadius: "20px",
          padding: "40px 30px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "72px",
            height: "72px",
            borderRadius: "50%",
            background: "#fff1f2",
            color: "#dc2626",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "34px",
            margin: "0 auto 20px",
            fontWeight: "bold",
          }}
        >
          ✕
        </div>

        <h1 style={{ margin: "0 0 10px", fontSize: "26px", fontWeight: "700", color: "#111827" }}>
          Paiement échoué
        </h1>
        <p style={{ margin: "0 0 28px", fontSize: "15px", lineHeight: "1.6", color: "#6b7280" }}>
          Le paiement a été annulé ou n'a pas pu être finalisé.
          <br />
          Veuillez réessayer ou nous contacter si le problème persiste.
        </p>

        <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
          <Link
            to="/promoteur/abonnement"
            style={{
              textDecoration: "none",
              background: "#078D3F",
              color: "#fff",
              padding: "12px 22px",
              borderRadius: "10px",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            Réessayer
          </Link>
          <Link
            to="/"
            style={{
              textDecoration: "none",
              background: "#f3f4f6",
              color: "#111827",
              padding: "12px 22px",
              borderRadius: "10px",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}